// Area Navigation component
import {
  type AreaNavigationProps,
  NavigationItem,
} from '@backoffice-frontend/patterns'
import { ServiceBreakLocationsAreaRoutes } from '@backoffice-frontend/service-break-locations-api'
import { MapPinIcon } from '@moia-dev/pace-icons'

// TODO: add your NavigationItem to the main menu
// check docs/how-tos/add-a-new-library.md for more info

export const ServiceBreakLocationsAreaNavigationIcon = MapPinIcon

export const ServiceBreakLocationsAreaNavigation = ({
  onClick,
  open,
  label,
}: AreaNavigationProps) => {
  return (
    <NavigationItem
      onClick={onClick}
      open={open}
      label={label}
      to={ServiceBreakLocationsAreaRoutes.route}
      Icon={MapPinIcon}
    />
  )
}
